/***  订单选择 发票    ***/
<template>
  <div class="invoiceOrderRecord">
    <pull-to :top-load-method="topRefreshFn" :bottom-load-method="content.length>=total?null:bottomRefreshFn">
      <div class="invoiceOrderRecord-row" v-for="(item,index) in content" :key="index"
           :ac="ids.includes(String(item.id))"
           @click="orderClickFn(item)">
        <div class="row-cont">
          <span class="row-check">
            <i class="iconfont icon-chenggong"></i>
          </span>
          <div class="row-col">
            <span class="iconfont icon-shijian1"></span>
            <span class="text">{{item.book_time}}</span>
          </div>
          <div class="row-col">
            <span class="iconfont icon-yuan" style="color: #3cafb9"></span>
            <span class="text">{{item.book_address}}</span>
          </div>
          <div class="row-col">
            <span class="iconfont icon-yuan" style="color: #f06553"></span>
            <span class="text">{{item.end_address}}</span>
          </div>
        </div>
        <div class="row-money">
          <span style="font-size: 2rem">{{item.total}}</span>元
        </div>
      </div>
    </pull-to>
    <div class="panel">
      <div class="panel-top">
        <span style="color: #f06553">{{ids.split(',').length-1}}</span>
        个订单，共
        <span style="color: #f06553">{{moneys}}</span>
        元
      </div>
      <div class="panel-bottom">
        <span @click="allCheckFn">
          <span class="all-check" :ac="allButState">
            <i class="iconfont icon-chenggong"></i>
          </span>
        全选
        </span>
        <span class="next" :ac="nextButState" @click="nextClickFn">下一步</span>
      </div>
    </div>
    <xk-upload-mod :state="loadState"></xk-upload-mod>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import XkInvoiceRecordMod from '../../module/invoiceRecordMod/src/invoiceRecordMod.vue'
  import XkUploadMod from '../../module/uploadMod/src/uploadMod.vue'
  import PullTo from 'vue-pull-to'

  export default {
    components: {
      XkUploadMod,
      PullTo,
      XkInvoiceRecordMod
    },
    name: 'invoiceRecord',
    computed: {
      ...mapGetters({
        loginData: 'loginData',
        invoiceRecord: 'invoiceRecord'
      })
    },
    data () {
      return {
        page: 1,
        rows: 4,
        total: 0,
        content: [],
        ids: '', // 选择的 订单
        moneys: 0,
        nextButState: false,
        allButState: false,
        loadState: false
      }
    },
    watch: {
      ids (val) {
        let length = (val.split(',').length - 1) || 0
        if (length > 0) {
          this.nextButState = true
        } else {
          this.nextButState = false
          this.moneys = 0
        }
        if (length === this.content.length) {
          this.allButState = true
        } else {
          this.allButState = false
        }
      }
    },
    methods: {
      loadDataButFn: function (loaded, type) { //  获取更多订单
        let that = this
        // that.loadState = true
        that.$store.dispatch('getInvoiceOrders', {
          'business': 'daijia',
          'page': that.page,
          'limit': that.rows,
          fn: (data) => {
            if (data && data.code === 1) {
              that.loadState = false
              let Data = data.invoiceOrders
              that.total = data.total
              let content = that.content
              if (type !== 'push') {
                content = []
              }
              Data.forEach((row) => {
                row.book_time = that.$utils.TimestampDate(row.book_time)
                content.push(row)
              })
              that.content = content
              if (loaded) {
                loaded('done')
              }
            }
          }
        })
      },
      bottomRefreshFn (loaded) {
        this.page++
        this.loadDataButFn(loaded, 'push')
      },
      topRefreshFn (loaded) {
        this.total = 1
        this.ids = ''
        this.loadDataButFn(loaded)
      },
      orderClickFn (order) { // 订单点击事件 id 订单id 号
        let id = order.id
        if (this.ids.includes(String(id))) {
          this.ids = this.ids.replace((String(id) + ','), '')
          this.moneys -= order.total || 0
        } else {
          this.ids += (id + ',')
          this.moneys += order.total || 0
        }
      },
      allCheckFn () { // 全选事件
        let allButState = this.allButState
        let content = this.content
        if (allButState) {
          this.ids = ''
          this.moneys = 0
        } else {
          let text = ''
          let moneys = 0
          content.forEach((row) => {
            text += (row.id + ',')
            moneys += row.total || 0
          })
          this.moneys = moneys
          this.ids = text
        }
      },
      nextClickFn () { // 下一步
        let that = this
        if (that.nextButState) {
          that.$router.push({path: '/invoiceApply', query: {ids: that.ids, moneys: that.moneys}})
        }
      }
    },
    mounted: function () {
      let that = this
      that.$store.dispatch('checkLogin', (state) => {
        if (state) {
          that.loadDataButFn()
        }
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .invoiceOrderRecord {
    width: 100%;
    box-sizing: border-box;
    height: 100vh;
    padding-bottom: 7rem;
    .invoiceOrderRecord-row {
      background: #fff;
      margin: 0 .5rem;
      border-radius: .4rem;
      margin-top: .5rem;
      padding: .8rem 1.2rem;
      padding-left: 3rem;
      position: relative;
      .row-col {
        width: 80%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 1.6rem;
        .iconfont {
          vertical-align: middle;
          font-size: 1rem;
        }
        .icon-shijian1 {
          /*color: #9d9d9d;*/
        }
        .text {
          vertical-align: middle;
        }
      }
      .row-money {
        position: absolute;
        right: .5rem;
        top: 50%;
        transform: translate(0, -50%);
      }
      .row-check {
        position: absolute;
        left: .5rem;
        top: 50%;
        transform: translate(0, -50%);
        width: 1.4rem;
        height: 1.4rem;
        line-height: 1.4rem;
        text-align: center;
        border-radius: 50%;
        border: 1px solid #eee;
        background: #fff;
        transition: .3s all;
        i {
          color: #fff;
          font-size: .6rem;
        }
      }
    }
    .invoiceOrderRecord-row[ac=true] {
      .row-check {
        background: #f06553;
        border-color: #f06553;
      }
    }
    .panel {
      box-sizing: border-box;
      position: fixed;
      left: 0;
      bottom: 0;
      width: 100%;
      background: #fff;
      padding: .5rem;
      padding-bottom: 0;
      box-shadow: 0 0 1rem rgba(0, 0, 0, .12);
      .panel-top {
        border-bottom: 1px solid #eee;
        line-height: 2rem;
        padding: 0 .5rem;
      }
      .panel-bottom {
        line-height: 4rem;
        padding: 0 .5rem;
        position: relative;
        font-size: 1.2rem;
      }
      .all-check {
        width: 1.4rem;
        height: 1.4rem;
        line-height: 1.4rem;
        text-align: center;
        border-radius: 50%;
        border: 1px solid #eee;
        background: #fff;
        margin-right: .2rem;
        transition: .3s all;
        i {
          color: #fff;
          font-size: .6rem;
        }
      }
      .all-check[ac=true] {
        background: #f06553;
        border-color: #f06553;
      }
      .next {
        display: inline-block;
        text-align: center;
        line-height: 2.5rem;
        width: 6rem;
        color: #999;
        background: #eee;
        position: absolute;
        right: 0;
        top: 50%;
        transform: translate(0, -50%);
        border-radius: .2rem;
        font-size: 1rem;
        transition: .3s all;
      }
      .next[ac=true] {
        color: #fff;
        background: #f06553;
      }
    }
    .wujilv {
      height: 40vh;
      padding-top: 30vh;
      h2 {
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// invoiceOrderRecord.vue?757c91d6